// Path
export const PERFORMANCE_HOME: string = "/gms/performance";
export const ANALYTICS_END_POINT: string = "analytics/dashboard";
export const ANALYTICS_REPORT_END_POINT: string = "analytics/dashboard/transactions";
export const ANALYTICS_METRIC_END_POINT: string = "analytics/dashboard/matrics";
export const ANALYTICS_GRAPH_END_POINT: string = "analytics/dashboard/graphs";
export const SUMMARY_REPORT_CSV_END_POINT: string = "analytics/dashboard/summary_report";
export const ARS_REPORT_CSV_END_POINT: string = "analytics/dashboard/ars_report";
export const PAGE_TITLE:string = "Performance";

// Date Menu Constants
export const TODAY: string = "Today(Timegrain-2H)";
export const YESTERDAY: string = "Yesterday(Timegrain-2H)";
export const LAST_7_DAYS: string = "Last 7 days(Timegrain-1D)";
export const LAST_30_DAYS: string = "Last 30 days(Timegrain-1D)";
export const LAST_MONTH: string = "Last Month(Timegrain-1D)";
export const LAST_3_MONTHS: string = "Last 3 Months(Timegrain-1W)";
export const THIS_YEAR_2W: string = "This year(Timegrain-2W)";
export const THIS_YEAR_1W: string = "This year(Timegrain-1W)";
export const THIS_YEAR_1M: string = "This year(Timegrain-1M)";
export const LAST_YEAR_1M: string = "Last year(Timegrain-1M)";
export const CUSTOM: string = "Custom";

// Date Compared Constants
export const NONE: string = "None";
export const PREVIOS_PERIOD: string = "Previous Period";
export const PRESENT: string = "Present";

// Metrics constants
export const ADD_TO_CART_RATES: string = "Add To Cart Rate";
export const ORDER_VALUE: string = "Order Value";
export const PRODUCTS_PURCHASED: string = "Products Purchased";

export const BILLABLE_VALUE_OF_PRODUCTS: string = "Billable Value of Products";
export const PERCENTAGE_OF_SALES: string = "Percentage of Sales";
export const UNIQUE_CUSTOMERS: string = "Unique Customers";
export const ORDER_CONVERSION_RATE: string = "Order Conversion Rate";
export const CART_CONVERSION_RATES: string = "Cart Conversion Rate";
export const IMPRESSIONS_COUNT: string = 'Impressions Count';
export const TIME_ZONE_MESSAGE: string = 'From start date, up to and including end date';
export const TIME_ZONE_LIMIT_MESSAGE: string = 'Please select a date range within the last three months for the reports.';
export const GENERATE_REPORT_MESSAGE: string = 'The generated report will be downloaded to the Downloads folder.';
export const COMMEND_REPORT: string = 'COMMEND';
export const SUMMARY_REPORT: string = 'SUMMARY';

// Granularity
export const PT2H: string = "PT2H";
export const P1D: string = "P1D";
export const P1W: string = "P1W";
export const P2W: string = "P2W";
export const P1M: string = "P1M";

export const DEFAULT_TIMEZONE = 'UTC';
export const DEFAULT_HEIGHT = 350;
export const DEFAULT_DECIMALS = 2;

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

